import React, { useRef } from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import Modal from '../shared/Modal';

const DeleteTodoModal = ({ open, onClose, todos, onConfirm, isMultiple = false }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open || !todos || todos.length === 0) return null;

    // Fonction pour extraire le texte brut du HTML
    const stripHtml = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sanitizeHtml(html || '');
        return tempDiv.textContent || tempDiv.innerText || '';
    };

    const todoCount = todos.length;
    const singleTodo = todoCount === 1 ? todos[0] : null;

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded-lg hover:bg-gray-400 dark:hover:bg-gray-600 transition"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={onConfirm}
                className="flex-1 bg-red-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-red-700 transition"
            >
                {isMultiple ? `Supprimer (${todoCount})` : 'Supprimer'}
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={isMultiple ? 'Supprimer les tâches' : 'Supprimer la tâche'}
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            {/* Body */}
            {isMultiple ? (
                <>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                        Êtes-vous sûr de vouloir supprimer <strong>{todoCount} tâches</strong> ?
                    </p>

                    <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 max-h-40 overflow-y-auto">
                        <ul className="space-y-2">
                            {todos.map((todo, idx) => (
                                <li key={todo._id} className="text-sm text-gray-700 dark:text-gray-300 flex items-start gap-2">
                                    <span className="text-gray-400 dark:text-gray-500 min-w-[20px]">{idx + 1}.</span>
                                    <span className="truncate">{stripHtml(todo.text)}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            ) : (
                <>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                        Êtes-vous sûr de vouloir supprimer cette tâche ?
                    </p>

                    <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
                        <p className="text-sm font-medium text-black dark:text-white mb-2 whitespace-pre-wrap break-words">
                            {stripHtml(singleTodo?.text)}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                            Créé par {singleTodo?.author} • {new Date(singleTodo?.createdAt).toLocaleDateString('fr-FR')}
                        </p>
                    </div>
                </>
            )}

            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded p-3 mt-4">
                <p className="text-sm text-yellow-800 dark:text-yellow-300">
                    ⚠️ Cette action est irréversible !
                </p>
            </div>
        </Modal>
    );
};

export default DeleteTodoModal;